import { render, staticRenderFns } from "./SettingOverview.vue?vue&type=template&id=53facbd0"
import script from "./SettingOverview.vue?vue&type=script&lang=js"
export * from "./SettingOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports